import InProgramVideoCallBookingContainer from './InProgramVideoCallBookingContainer'

export default InProgramVideoCallBookingContainer
